'use client';

import { useState, useRef, useEffect } from 'react';
import { cn } from 'common/utils';

interface ForumThreeDotMenuPropsType {
  onDelete: () => void;
}

const ForumThreeDotMenu = ({ onDelete }: ForumThreeDotMenuPropsType) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleDelete = () => {
    setIsOpen(false);
    onDelete();
  };

  return (
    <div ref={menuRef} className="relative">
      <button
        type="button"
        onClick={() => setIsOpen((prev) => !prev)}
        className="flex size-8 cursor-pointer items-center justify-center rounded-full border-none bg-transparent transition-colors hover:bg-gray-100"
        aria-label="メニュー"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="currentColor"
          className="text-pp-text-secondary"
        >
          <circle cx="12" cy="5" r="2"></circle>
          <circle cx="12" cy="12" r="2"></circle>
          <circle cx="12" cy="19" r="2"></circle>
        </svg>
      </button>

      {/* Dropdown menu */}
      <div
        className={cn(
          'absolute right-0 top-full z-50 mt-1 min-w-[120px] overflow-hidden rounded-lg border border-gray-200 bg-white shadow-lg transition-all duration-200',
          isOpen
            ? 'visible translate-y-0 opacity-100'
            : 'invisible -translate-y-2 opacity-0',
        )}
      >
        <button
          type="button"
          onClick={handleDelete}
          className="flex w-full cursor-pointer items-center gap-2 border-none bg-transparent px-4 py-3 text-left text-sm text-red-500 transition-colors hover:bg-red-50"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="3,6 5,6 21,6"></polyline>
            <path d="M19,6v14a2,2 0 0,1 -2,2H7a2,2 0 0,1 -2,-2V6m3,0V4a2,2 0 0,1 2,-2h4a2,2 0 0,1 2,2v2"></path>
            <line x1="10" y1="11" x2="10" y2="17"></line>
            <line x1="14" y1="11" x2="14" y2="17"></line>
          </svg>
          削除
        </button>
      </div>
    </div>
  );
};

export default ForumThreeDotMenu;
